import Autoinput from './src/main'

Autoinput.install = function (Vue) {
    Vue.component(Autoinput.name, Autoinput)
}
/**
 * 根据输入类容，自动获取提示内容
 * 说明：此组件是将AutoComple组件进行改造
 */
export default Autoinput